import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  root: {
    display: 'flex',
    minWidth: theme.spacing(83),
    flexDirection: 'column',
    gap: theme.spacing(5),
    boxSizing: 'border-box',
    height: '100%',
  },
  rootModal: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    height: '100%',
  },
  sfSearchedSpace: {
    gap: theme.spacing(0),
  },
  checkIcon: {
    width: theme.spacing(2),
    height: theme.spacing(2),
  },
}))
